import React from "react";
import Filters from "../components/form/Filters";

const MessageTypeFilters = (props) => <Filters {...props} />;
export default MessageTypeFilters;
